module.exports = __webpack_public_path__ + "static/media/s3-bottom-left-1.f99adb83.png";